import { ComponentProps } from 'react'
import { BlockIcon } from '@/components/icons/block-icon'

export const CheckIcon = (props: Omit<ComponentProps<typeof BlockIcon>, 'icon'>) => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path d="M20 6L9 17L4 12" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
	</svg>
)
